import React from 'react';
import { inject, observer } from 'mobx-react';

@inject('workflowStore')
@observer
export default class Main extends React.Component {
  constructor(props) {
    super(props);
  }

  onClick = (value) => {
    const { onClick = () => {} } = this.props;
    typeof onClick === 'function' && onClick(value);
  }

  render() {
    const { datas, otherColor, className } = this.props;
    return (
      <div className={`workflow-form-list ${className}`}>
        <ul className='workflow-form-list-data'>
          {
            datas && datas.length > 0 && datas.map((item, index) => {
              return (
                <li key={index} className={otherColor ? "other-color" : ""} onClick={() => this.onClick(item)} >
                  <span className="download-title" title={item.title}>{item.title}</span>
                  <span className="download-number">{item.downloadCounts}</span>
                </li>
              );
            })
          }
        </ul>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/workflow/FormList.js